export default {"src":"/_next/static/media/ic-price-gray.8693ba4f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};